/* tslint:disable */
/* eslint-disable */
/**
 * extractor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface Filtre {
    'geo'?: GeoRef;
    'typesDeBiens'?: Array<TypeDeBiens>;
    'syndic'?: boolean;
    'copro'?: boolean;
    'nbLgts'?: number;
    'Dpes'?: Array<string>;
    'output'?: GeoLocOutput;
}



export const GeoLocOutput = {
    BanLatLon: 'BAN_LAT_LON',
    BanSecondaryLatLon: 'BAN_SECONDARY_LAT_LON',
    PolygonBatGroupe: 'POLYGON_BAT_GROUPE',
    PolygonConstructionGroupe: 'POLYGON_CONSTRUCTION_GROUPE',
    PolygonParcelle: 'POLYGON_PARCELLE'
} as const;

export type GeoLocOutput = typeof GeoLocOutput[keyof typeof GeoLocOutput];


export interface GeoRef {
    'commune'?: string;
    'departement'?: string;
    'region'?: string;
    'epci'?: string;
}

export const TypeDeBiens = {
    SurfaceUtile: 'SURFACE_UTILE',
    TypeDeProprietaire: 'TYPE_DE_PROPRIETAIRE',
    TypeDeBatiment: 'TYPE_DE_BATIMENT',
    PeriodeDeConstruction: 'PERIODE_DE_CONSTRUCTION'
} as const;

export type TypeDeBiens = typeof TypeDeBiens[keyof typeof TypeDeBiens];



/**
 * ApiExtractorCtrlApi - axios parameter creator
 */
export const ApiExtractorCtrlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Export Bdndb All
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBdnbAllPost: async (filtre: Filtre, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filtre' is not null or undefined
            assertParamExists('apiBdnbAllPost', 'filtre', filtre)
            const localVarPath = `/api/bdnb/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(filtre, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export Dpe Data
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDpePost: async (filtre: Filtre, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filtre' is not null or undefined
            assertParamExists('apiDpePost', 'filtre', filtre)
            const localVarPath = `/api/dpe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(filtre, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export Etab Data
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEtabPost: async (filtre: Filtre, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filtre' is not null or undefined
            assertParamExists('apiEtabPost', 'filtre', filtre)
            const localVarPath = `/api/etab`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(filtre, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiExtractorCtrlApi - functional programming interface
 */
export const ApiExtractorCtrlApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApiExtractorCtrlApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Export Bdndb All
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBdnbAllPost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: Array<{ [key: string]: string; }>; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBdnbAllPost(filtre, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiExtractorCtrlApi.apiBdnbAllPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export Dpe Data
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDpePost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<{ [key: string]: string; }>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDpePost(filtre, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiExtractorCtrlApi.apiDpePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export Etab Data
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiEtabPost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<{ [key: string]: string; }>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiEtabPost(filtre, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApiExtractorCtrlApi.apiEtabPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ApiExtractorCtrlApi - factory interface
 */
export const ApiExtractorCtrlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApiExtractorCtrlApiFp(configuration)
    return {
        /**
         * 
         * @summary Export Bdndb All
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBdnbAllPost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: Array<{ [key: string]: string; }>; }> {
            return localVarFp.apiBdnbAllPost(filtre, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export Dpe Data
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDpePost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<{ [key: string]: string; }>> {
            return localVarFp.apiDpePost(filtre, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export Etab Data
         * @param {Filtre} filtre 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiEtabPost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<{ [key: string]: string; }>> {
            return localVarFp.apiEtabPost(filtre, limit, offset, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApiExtractorCtrlApi - object-oriented interface
 */
export class ApiExtractorCtrlApi extends BaseAPI {
    /**
     * 
     * @summary Export Bdndb All
     * @param {Filtre} filtre 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiBdnbAllPost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return ApiExtractorCtrlApiFp(this.configuration).apiBdnbAllPost(filtre, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export Dpe Data
     * @param {Filtre} filtre 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDpePost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return ApiExtractorCtrlApiFp(this.configuration).apiDpePost(filtre, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export Etab Data
     * @param {Filtre} filtre 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiEtabPost(filtre: Filtre, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return ApiExtractorCtrlApiFp(this.configuration).apiEtabPost(filtre, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }
}



